import { Icon } from "@trustpilot/constellation-components";
import { externalLink_16 as externalLink } from "@trustpilot/icons";

import { StyledLink, StyledList, StyledListItem } from "../styled";
import { StyledItemText } from "./styled";
import * as Types from "./types";

const AccountManager: React.FC<Types.AccountManager> = ({ accountmanager }) => (
  <StyledList className="account-manager">
    {accountmanager.name && accountmanager.name.length > 0 && (
      <StyledListItem cursor="default">
        <StyledItemText>{accountmanager.name}</StyledItemText>
      </StyledListItem>
    )}
    {accountmanager.email && accountmanager.email.length > 0 && (
      <StyledListItem>
        <StyledLink href={`mailto:${accountmanager.email}`} target="_blank">
          <StyledItemText>{accountmanager.email}</StyledItemText>
          <Icon content={externalLink} />
        </StyledLink>
      </StyledListItem>
    )}
    {accountmanager.phone && accountmanager.phone.length > 0 && (
      <StyledListItem cursor="default">
        <StyledItemText>{accountmanager.phone}</StyledItemText>
      </StyledListItem>
    )}
  </StyledList>
);

export default AccountManager;
